import React, {FunctionComponent} from 'react';
import cn from 'classnames';
import Icon from './Icon';
import {IconProps} from './IconProps';

const IconFullStar: FunctionComponent<IconProps> = ({
  className, height = '1em', title,
}) =>
  (
    <Icon className={cn('inline-block', className)} height={height} title={title}>
      M17.47 7.36129L12.9075 6.70529L10.845 2.55063C10.5013 1.83216 9.43875 1.80092 9.06375 2.55063L7.0325
      6.70529L2.43875 7.36129C1.62625 7.48624 1.31375 8.48585 1.9075 9.07938L5.18875 12.2969L4.4075 16.8264C4.2825
      17.6386 5.1575 18.2633 5.87625 17.8885L9.97 15.7331L14.0325 17.8885C14.7513 18.2633 15.6263 17.6386 15.5013
      16.8264L14.72 12.2969L18.0012 9.07938C18.595 8.48585 18.2825 7.48624 17.47 7.36129Z
    </Icon>
  );

export default IconFullStar;
